function fallbackCopyText(text, onSuccess, onFail) {
    let textArea = document.createElement('textarea')
    textArea.value = text
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
        let successful = document.execCommand('copy')
        if (successful) {
            if (onSuccess) {
                onSuccess()
            }
        } else {
            if (onFail) {
                onFail()
            }
        }
    } catch (err) {
        if (onFail) {
            onFail()
        }
    }
    document.body.removeChild(textArea)
}

export function copyText(text, onSuccess, onFail) {
    if (navigator.clipboard) {
        try {
            navigator.clipboard.writeText(text).then(
                function () {
                    if (onSuccess) {
                        onSuccess()
                    }
                },
                function (err) {
                    fallbackCopyText(text, onSuccess, onFail)
                }
            )
        } catch (err) {
            fallbackCopyText(text, onSuccess, onFail)
        }
    } else {
        fallbackCopyText(text, onSuccess, onFail)
    }
}
